var _defs, _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.088123 11.988124",
    xmlSpace: "preserve",
    width: 20.088123,
    height: 11.988124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs17"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style10"
  }, "\n\t.st0{fill:#000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 12.763124,10.063124 6.8,-6.8000004 c 0.7,-0.7 0.7,-1.9 0,-2.69999998 v 0 c -0.7,-0.7 -2,-0.8 -2.7,0 l -6.8,6.79999998 -6.8000004,-6.79999998 c -0.7,-0.7 -1.9,-0.7 -2.69999998,0 v 0 c -0.7,0.69999998 -0.8,1.99999998 0,2.69999998 l 6.79999998,6.8000004 1.4,1.4 c 0.7,0.7 1.9000004,0.7 2.7000004,0 z",
    id: "path12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.2e8bf342c7640d8578675ec6ffd8f90e.svg";
export { ForwardRef as ReactComponent };